import { CollectingTaskListItem } from './collecting-task-list-item';
import { DeliveringTaskListItem } from './delivering-task-list-item';
import { ReturningTaskListItem } from './returning-task-list-item';
import { RefundingTaskListItem } from './refunding-task-list-item';
import { ContainerPlacingTaskListItem } from './container-placing-task-list-item';

export class TaskList {
    public collectingTasks: CollectingTaskListItem[];
    public containerPlacingTasks: ContainerPlacingTaskListItem[];
    public deliveringTasks: DeliveringTaskListItem[];
    public returningTasks: ReturningTaskListItem[];
    public refundingTasks: RefundingTaskListItem[];
    public supplierWorktimeIsActive: boolean;
    public useDynamicRouting: boolean;
    public maximumMultipickingTasks: number;
    public supplierID: string;
    public supplierRegionID: string;
    public isAssignedToSplitShift: boolean;
    public today: Date;
    public worktimeBlocks: WorktimeTaskBlock[];
    public unplannedCollectingOrderIDs: number[];
    public unplannedDeliveringOrderIDs: number[];
    public activeWorktime: WorktimeInterval;
    public additionalWorktimes: WorktimeInterval[];
    public pickingToDeliveryDeadline: Date;
    public partnerStoresMapUrl: string;
}

export class WorktimeInterval {
    public id: string;
    public supplierRegionID: string;
    public start: Date;
    public end: Date;
}

export class WorktimeTaskBlock extends WorktimeInterval {
    public isActive: boolean;
    public pickingToDeliveryDeadline: Date;
    public collectingOrderIDs: number[];
    public deliveringOrderIDs: number[];
}
